import { z } from 'zod';

export const homeContentImageSchema = z
	.object({
		url: z.string(),
		altText: z.string().optional(),
		length: z.number().optional(),
		mimeType: z.string().optional(),
	})
	.passthrough();

export const homeContentVideoSchema = z
	.object({
		provider: z.string().optional(),
		reference: z.string().optional(),
		duration: z.string().optional(),
	})
	.passthrough();

export const homeContentAuthorSchema = z
	.object({
		id: z.string().optional(),
		name: z.string().optional(),
		imageUrl: z.string().optional(),
		twitterHandle: z.string().optional(),
	})
	.passthrough();

export const homeContentTagSchema = z.object({
	href: z.string(),
	title: z.string(),
});

export const homeContentItemSchema = z
	.object({
		id: z.string(),
		language: z.string().optional(),
		title: z.string(),
		summary: z.string().optional(),
		isShorthandPage: z.boolean().optional(),
		isSignInRequired: z.boolean().optional(),
		isPremium: z.boolean().optional(),
		availableInCityzensFeed: z.boolean().optional(),
		publishedDate: z.string().optional(),
		createdDate: z.string().optional(),
		updatedDate: z.string().optional(),
		categoryName: z.string().optional(),
		primaryTag: z.string().optional(),
		_links: z
			.object({
				self: z.object({ href: z.string() }).optional(),
				'content:webpage': z.object({ href: z.string() }).optional(),
				'content:amp': z.object({ href: z.string() }).optional(),
				'content:tags': z.array(homeContentTagSchema).optional(),
				'content:related': z.unknown().optional(),
			})
			.passthrough()
			.optional(),
		_embedded: z
			.object({
				image: homeContentImageSchema.optional(),
				imageVariants: z.array(z.unknown()).optional(),
				authors: z.array(homeContentAuthorSchema).optional(),
				photographers: z.array(z.unknown()).optional(),
				noAds: z.boolean().optional(),
				fixtureId: z.number().optional(),
				video: homeContentVideoSchema.optional(),
			})
			.passthrough()
			.optional(),
	})
	.passthrough();
